// Tracking system select change event
import { ErrorItem } from '../components/ErrorsPresenter/ErrorsPresenter';
import { AppInfo } from '../typings/mobile-apps';
import { AppTracker, JavaAppTrackersTemplates, TrackingParametersId } from '../typings/trackingParametersEditor';

export enum TrackingParametersEditorActionType {
    TRACKING_SYSTEM_CHANGE = '@TrackingParametersEditorAction/TRACKING_SYSTEM_CHANGE',
    UPDATE_APP_TRACKERS_TEMPLATES = '@TrackingParametersEditorAction/UPDATE_APP_TRACKERS_TEMPLATES',
    UPDATE_APP_TRACKERS_ERRORS = '@TrackingParametersEditorAction/UPDATE_APP_TRACKERS_ERRORS',
    SET_APP_TRACKERS_MOBILE_OS_TYPE = '@TrackingParametersEditorAction/SET_APP_TRACKERS_MOBILE_OS_TYPE',
    UPDATE_APP_TRACKERS_TRACKER_DATA = '@TrackingParametersEditorAction/UPDATE_APP_TRACKERS_TRACKER_DATA',
    UPDATE_APP_TRACKERS_APP_INFO = '@TrackingParametersEditorAction/UPDATE_APP_TRACKERS_APP_INFO',
    FETCH_APP_TRACKERS_TEMPLATES = '@TrackingParametersEditorAction/FETCH_APP_TRACKERS_TEMPLATES'
}

interface TrackingParametersEditorBaseAction {
    editorId: string;
}

export interface TrackingSystemChange extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.TRACKING_SYSTEM_CHANGE;
    tracker: AppTracker;
}

export function trackingSystemChange(editorId: TrackingParametersId, tracker: AppTracker): TrackingSystemChange {
    return {
        type: TrackingParametersEditorActionType.TRACKING_SYSTEM_CHANGE,
        tracker,
        editorId
    };
}

export interface UpdateAppTrackersAppInfo extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_APP_INFO;
    appInfo?: AppInfo;
}

export function updateAppTrackersAppInfo(editorId: TrackingParametersId, appInfo?: AppInfo): UpdateAppTrackersAppInfo {
    return {
        type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_APP_INFO,
        appInfo,
        editorId
    };
}

export interface UpdateAppTrackersTemplates extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_TEMPLATES;
    trackersTemplates: JavaAppTrackersTemplates;
}

export function updateAppTrackersTemplates(
    editorId: TrackingParametersId,
    trackersTemplates: JavaAppTrackersTemplates
): UpdateAppTrackersTemplates {
    return {
        type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_TEMPLATES,
        trackersTemplates,
        editorId
    };
}

export interface UpdateAppTrackersErrors extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_ERRORS;
    errors: ErrorItem[];
}

export function updateAppTrackersErrors(editorId: TrackingParametersId, errors: ErrorItem[]): UpdateAppTrackersErrors {
    return {
        type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_ERRORS,
        errors,
        editorId
    };
}

export interface SetAppTrackersMobileOsType extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.SET_APP_TRACKERS_MOBILE_OS_TYPE;
    osType: string;
}

export function setAppTrackersMobileOsType(editorId: TrackingParametersId, osType: string): SetAppTrackersMobileOsType {
    return {
        type: TrackingParametersEditorActionType.SET_APP_TRACKERS_MOBILE_OS_TYPE,
        osType,
        editorId
    };
}

export interface UpdateAppTrackersTrackerData extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_TRACKER_DATA;
    tracker: AppTracker;
}

export function updateAppTrackersTrackerData(
    editorId: TrackingParametersId,
    tracker: AppTracker
): UpdateAppTrackersTrackerData {
    return {
        type: TrackingParametersEditorActionType.UPDATE_APP_TRACKERS_TRACKER_DATA,
        tracker,
        editorId
    };
}

export interface FetchAppTrackersTemplates extends TrackingParametersEditorBaseAction {
    type: TrackingParametersEditorActionType.FETCH_APP_TRACKERS_TEMPLATES;
    login: string;
}

export function fetchAppTrackersTemplates(editorId: TrackingParametersId, login: string): FetchAppTrackersTemplates {
    return {
        type: TrackingParametersEditorActionType.FETCH_APP_TRACKERS_TEMPLATES,
        login,
        editorId
    };
}

export type TrackingParametersEditorActions =
    | TrackingSystemChange
    | UpdateAppTrackersTemplates
    | FetchAppTrackersTemplates
    | UpdateAppTrackersErrors
    | UpdateAppTrackersTrackerData
    | UpdateAppTrackersAppInfo
    | SetAppTrackersMobileOsType;
